import { bindActionCreators, } from 'redux';
import { connect, } from 'react-redux';
import * as SignupAction from '../actions/Signup';
import * as SigninAction from '../actions/Signin';
import SignIn from './SignIn';

function mapStateToProps(state) {
  return {
    login: state.signin,
    register: state.signup,
  }
}
function mapDispachToProps(dispatch) {
  return bindActionCreators(Object.assign({}, SigninAction, SignupAction), dispatch);
}
const SignInContainer = connect(mapStateToProps, mapDispachToProps)(SignIn);
export default SignInContainer;



/** WEBPACK FOOTER **
 ** ./src/components/SignInContainer.js
 **/